<script>
    // Added because migrating progress.svelte needed it twice, not because it
    // seemed like a good idea in the abstract. A small uppercase token for a
    // concern, a tag, an ingredient.
    //
    //   <Chip>Dry skin</Chip>
    //   <Chip tone="caution" value="62%">Large pores</Chip>
    //
    // `value` is rendered after the label in the accent colour, so a concern
    // and its score read as one object rather than two.

    export let tone = 'default'; // default | success | caution | danger
    export let value = null;
</script>

<style>
    .chip {
        display: inline-flex;
        align-items: baseline;
        gap: var(--space-1);
        border: 1px solid var(--border);
        border-radius: var(--radius-0);
        padding: var(--space-1) var(--space-2);
        font-size: var(--text-3xs);
        letter-spacing: var(--track-label);
        text-transform: uppercase;
        color: var(--text-muted);
        white-space: nowrap;
    }

    .success { border-color: var(--success); color: var(--success); }
    .caution { border-color: var(--caution); color: var(--caution); }
    .danger  { border-color: var(--danger);  color: var(--danger); }

    .value { color: var(--cream); font-weight: var(--weight-medium); }
    .success .value, .caution .value, .danger .value { color: inherit; }
</style>

<span class="chip {tone}">
    <slot />
    {#if value}<span class="value">{value}</span>{/if}
</span>
